<template>
  <div id="focus_area_window_content">
    <form
      name="focus_area_form"
      @submit.prevent.stop='saveFocusPoint'
      class="focus_area_form clearfix"
    >
      <div class="fp_container_left">
        <h1>{{ LANG.setFocusPoint }}</h1>

        <div class="img_container">
          <div ref="fp_image" @click="(event) => clickFocusPoint(event)" id="action_crop_con">
            <img
              :src="imageUriVersion"
              alt="Focus area image"
              id="action_crop"
              ref="action_crop"
              class="img-responsive"
            />
            <img
              src="/imperia/images/fp_cursor.png"
              draggable="false"
              id="fp_img"
              :style="`top: ${focusPointY - focusPointRadius}px; left: ${focusPointX - focusPointRadius}px;`"
            />
          </div>
        </div>
      </div>

      <div class="fp_container_left">
        <h1 class="title_previews">{{ LANG.previews }}</h1>
        <div v-if="dataLoaded" class="previews">
          <ModalFocusPointFrame id="frame_3_1" :imageUri="imageUriVersion" :focusX="focusX" :focusY="focusY" :imageH="imageHeight" :imageW="imageWidth"/>
          <ModalFocusPointFrame id="frame_2_2" :imageUri="imageUriVersion" :focusX="focusX" :focusY="focusY" :imageH="imageHeight" :imageW="imageWidth"/>
          <ModalFocusPointFrame id="frame_1_2" :imageUri="imageUriVersion" :focusX="focusX" :focusY="focusY" :imageH="imageHeight" :imageW="imageWidth"/>
        </div>
      </div>
      <button
        ref='button'
        type='submit' class='hidden'>{{LANG.save}}</button>
    </form>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { showToast } from '@/utils/tools';
import fetchService from '@/utils/model/fetch_service';

import ModalFocusPointFrame from './ModalFocusPointFrame.vue';

export default defineComponent({
  components: {
    ModalFocusPointFrame,
  },
  props: {
    document: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  data: () => ({
    imageUri: '#',
    focusPointX: Number,
    focusPointY: Number,
    imageWidth: Number,
    imageHeight: Number,
    focusPointRadius: 50,
    dataLoaded: false,
    focusX: Number,
    focusY: Number,
  }),
  async mounted() {
    const params = {
      node_id: this.nodeId,
    };
    const response = await fetchService.GetData('docbrowser_focus_point', params);
    const { data } = response;

    this.imageUri = data.image_uri;
    this.imageWidth = data.image_width;
    this.imageHeight = data.image_height;
    this.focusPointX = data.focuspoint_x;
    this.focusPointY = data.focuspoint_y;

    const imgElement = this.$refs.action_crop;
    imgElement.addEventListener('load', this.initImageFocusPoint);
  },
  computed: {
    ...mapState(['LANG']),
    nodeId() {
      return this.document.node_id;
    },
    previewVersion() {
      return btoa(this.document.finished_at);
    },
    imageUriVersion() {
      return `${this.imageUri}?v=${this.previewVersion}`;
    },
  },
  methods: {
    initImageFocusPoint() {
      const imgElement = this.$refs.action_crop;
      const factor = imgElement.offsetWidth / this.imageWidth;

      const tempFPX = this.focusPointX || this.imageWidth / 2;
      const tempFPY = this.focusPointY || this.imageHeight / 2;

      this.focusPointX = tempFPX * factor;
      this.focusPointY = tempFPY * factor;

      this.setFocusPoint(this.focusPointX, this.focusPointY);
      this.dataLoaded = true;
    },
    clickFocusPoint(event) {
      const fpImage = this.$refs.fp_image;
      const mouseX = event.clientX;
      const mouseY = event.clientY;

      const offset = fpImage.getBoundingClientRect();

      this.focusPointX = mouseX - offset.left;
      this.focusPointY = mouseY - offset.top;

      this.setFocusPoint(this.focusPointX, this.focusPointY);
    },
    setFocusPoint(fpX, fpY) {
      fpX = Math.round(fpX); // eslint-disable-line
      fpY = Math.round(fpY); // eslint-disable-line

      const imgElement = this.$refs.action_crop;
      const imgW = imgElement.offsetWidth;
      const imgH = imgElement.offsetHeight;

      // Calculate FocusPoint coordinates
      const offsetX = fpX;
      const offsetY = fpY;
      this.focusX = (offsetX / imgW - 0.5) * 2;
      this.focusY = (offsetY / imgH - 0.5) * -2;
    },
    async saveFocusPoint() {
      const imgElement = this.$refs.action_crop;
      const factor = imgElement.offsetWidth / this.imageWidth;

      const params = {
        node_id: this.nodeId,
        focuspoint_x: (this.focusPointX) / factor,
        focuspoint_y: (this.focusPointY) / factor,
      };

      const response = await fetchService.GetData('docbrowser_focus_point_save', params);

      showToast(response.message, response.error);
    },
  },
});
</script>

<style scoped lang='scss'>
html {
  height: 100% !important;
}
#focus_area_window_content {
  max-height: 600px;
}
.focus_area_form {
  height: 100%;
}
#focuspoint_x, #focuspoint_y {
  width: 60px;
  height: 20px;
  font-size: 11px;
}
.focus_area_form .img_container {
  height: 500px;
  width: 500px;
  overflow: hidden;
  background: #1c3960;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  border: 2px solid #1c3960;
}
.focus_area_form .img_container img#action_crop {
  max-height: 490px;
  max-width: 500px;
  width: auto;
  height: auto;
  margin: auto 0;
}
.focus_area_form .img_container #action_crop_con {
  overflow: hidden;
  margin: auto;
  width: auto !important;
  display: inline-block;
  background-color: red;
}
.action_crop_settings label {
  font-size: 11px;
}
.action_crop_settings > div {
  padding: 4px 5px 3px 5px;
}
.img_container .hint {
  margin: 10px 3px;
  font-size: 12px;
  font-style: italic;
}
.focuspoint {
  overflow: hidden;
  background: #efefef;
  float: left;
  position: relative;
}
#action_crop {
  margin: auto;
}
.previews {
  background-color: #fff;
}
.previews > div > img {
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transition: all 500ms ease-in-out;
  -moz-transition: all 500ms ease-in-out;
  transition: all 500ms ease-in-out;
}
.previews #frame_3_1 {
  width: 100%;
  height: 33%;
  border: 2px solid #1c3960;
  background-color: #efefef;
  margin-bottom: 2px;
}
.previews #frame_2_2 {
  width: calc(66.5% - 2px);
  height: 66.5%;
  border: 2px solid #1c3960;
  background-color: #efefef;
  margin-right: 2px;
}
.previews #frame_1_2 {
  width: 33.5%;
  height: 66.5%;
  border: 2px solid #1c3960;
  background-color: #efefef;
}
#fp_img {
  position: absolute;
  z-index: 1000;
  width: 100px;
  height: 100px;
  left: 0px;
  top: 0px;
}
#action_crop_con {
  max-width: 1920px;
  width: 1920px;
  height: 1080px;
  position: relative;
}
/* !FOCUSED IMAGES */
/*-----------------------------------------*/
.focuspoint {
  position: relative; /*Any position but static should work*/
  overflow: hidden;
}
.focuspoint img {
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  display: block;
  /* fill and maintain aspect ratio */
  width: auto; height: auto;
  min-width: 100%; min-height: 100%;
  max-height: none; max-width: none;
}
</style>
